import { Instance } from '@sleipai/sleip-models';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import * as InstanceActions from '../actions/instance.actions';

export const instanceFeatureKey = 'instance';

export interface State extends EntityState<Instance> {
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

export function selectInstanceId(a: Instance) {
  return a.id;
}

export function sortByName(a: Instance, b: Instance) {
  return a.status.localeCompare(b.status);
}

export const adapter: EntityAdapter<Instance> = createEntityAdapter<Instance>({
  selectId: selectInstanceId,
  sortComparer: sortByName,
});

export const initialState: State = adapter.getInitialState({
  loading: false,
  loaded: true,
  error: null,
});

const instanceReducer = createReducer(
  initialState,
  on(InstanceActions.loadInstances, (state) => {
    return {
      ...state,
      loaded: false,
      loading: true,
    };
  }),
  on(InstanceActions.loadInstancesSuccess, (state, { instances }) => {
    return adapter.upsertMany(instances, {
      ...state,
      loaded: true,
      loading: false,
    });
  }),
  on(InstanceActions.addrandom, (state) => {
    return { ...state, loaded: true };
  })
);

// get the selectors
export const {
  selectIds: selectInstanceIdsAdapter,
  selectEntities: selectInstanceEntitiesAdapter,
  selectAll: selectAllInstancesAdapter,
  selectTotal: selectInstancesTotalAdapter,
} = adapter.getSelectors();

export function reducer(state: State | undefined, action: Action) {
  return instanceReducer(state, action);
}
